import { FC } from "react";
import styles from "./index.module.css";
import { Link } from "react-router-dom";
import Logo from "../../assets/guru.svg";
import { useLanguage } from "../../context/LanguageContext";

const FooterLogo = () => {
  const { t } = useLanguage();
  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <mui-h-stack alignY="center" space="var(--space-400)">
        <img src={Logo} alt="Guru Logo" style={{ width: "28px", height: "28px" }} />
        <mui-h-stack space="var(--space-300)">
          <mui-heading level="3" size="3">
            {t("guru.title")}
          </mui-heading>
        </mui-h-stack>
      </mui-h-stack>
    </Link>
  );
};

const FooterLinks = () => {
  const { t } = useLanguage();
  return (
    <mui-h-stack space="var(--space-800)" alignY="start">
      <mui-v-stack space="var(--space-500)" alignX="start">
        <mui-heading level="5" size="5">
          {t("footer.title.app")}
        </mui-heading>
        <mui-link href="/guides">{t("guides.title")}</mui-link>
        <mui-link href="/outcomes">{t("outcomes.title")}</mui-link>
      </mui-v-stack>
      <mui-v-stack space="var(--space-500)" alignX="start">
        <mui-heading level="5" size="5">
          {t("footer.title.plugins")}
        </mui-heading>
        <mui-link href="https://www.figma.com/community/plugin/1471341082690554711/guru-guides" target="_blank">
          {t("footer.plugins.guides")}
        </mui-link>
        <mui-link href="https://github.com/guru-app-team/guru-outcomes-plugin" target="_blank">
          {t("footer.plugins.outcomes")}
        </mui-link>
      </mui-v-stack>
      <mui-v-stack space="var(--space-500)" alignX="start">
        <mui-heading level="5" size="5">
          {t("footer.title.contact")}
        </mui-heading>
        <mui-link href="mailto:guruapp@proton.me?subject=Hello&body=I%20need%20help%20setting%20up%20guru%20guides.">
          {t("navigation.email")}
        </mui-link>
      </mui-v-stack>
    </mui-h-stack>
  );
};

const Footer: FC = () => {
  return (
    <div className={styles.footer}>
      <mui-responsive breakpoint="800">
        <mui-h-stack alignY="start" alignX="space-between" slot="showAbove">
          <FooterLogo />
          <FooterLinks />
        </mui-h-stack>

        <mui-v-stack alignY="start" alignX="space-between" slot="showBelow">
          <FooterLogo />
          <FooterLinks />
        </mui-v-stack>
      </mui-responsive>
    </div>
  );
};

export default Footer;
